import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    globalBackStatus: true,
    globalHomeStatus: true,
    // 判断右上回家按钮是否隐藏
    homeBack: true,
    // 判断左上后退按钮是否隐藏
    selectTagImg: true,
    //获得隐藏div数据
    selectContent: [],
    speciaStatus: null,
    imgListStatus: true
  },
  mutations: {
    setGlobalBack(state, value) {
      state.globalBackStatus = value;
    },
    setGlobalHome(state, value) {
      state.globalHomeStatus = value;
    },
    setHomeBack(state, value) {
      state.homeBack = value;
    },
    setSelectTagImg(state, value) {
      state.selectTagImg = value;
    },
    setSelectContent(state, value) {
      state.selectContent = value;
    },
    setSpeciaStatus(state, value) {
      state.speciaStatus = value;
    },
    setImgListStatus(state, value) {
      state.imgListStatus = value;
    }
  },
  actions: {},
  modules: {}
});
